export default __webpack_public_path__ + "assets/checkbox.cae9ae68.svg";